import { Text, type TextProps } from 'react-aria-components/Text';

import styles from './field_description.module.css';

/** Field description / help text */
export function FieldDescription(props: TextProps) {
  return (
    <Text className={styles.field_description} slot="description" {...props} />
  );
}
